import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import ProminentWorksList from '../../Utils/ProminentWorksList';
import ProminentWorksDetails from '../ProminentWorks/ProminentWorksDetails';
import './ProjectsList.scss';
import { MIXPANEL_EVENTS, track } from '../../Utils/mixpanel';

const ProjectsList = ({ dataList, setDataList }) => {
  const [isLoading, setIsLoading] = useState(false);
  const lastBoxRef = useRef(null);

  useEffect(() => {
    setDataList(ProminentWorksList.slice(0, 4));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    function handleScroll() {
      if (
        lastBoxRef.current &&
        lastBoxRef.current.getBoundingClientRect().bottom <= window.innerHeight
      ) {
        setIsLoading(true);
      }
    }

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        const newDataList = [
          ...dataList,
          ...ProminentWorksList.slice(dataList.length, dataList.length + 4)
        ];
        setDataList(newDataList);
        setIsLoading(false);
      }, 500);
    }
  }, [dataList, isLoading, setDataList]);

  return (
    <div className="container">
      <div className="project-list">
        {dataList.map((item, index) => (
          <div
            className="project-case-study"
            key={index}
            ref={index === dataList.length - 1 ? lastBoxRef : null}>
            <Link
              to={`/case-study/${item.path}`}
              onClick={() => {
                track(MIXPANEL_EVENTS.CASE_STUDY_CARD_CLICKED, {
                  case_study_slug: item.path,
                  case_study_title: item.subTitle
                });
                window.scrollTo(0, 0);
              }}>
              <div
                className={`project-list-content ${item.bgType === 'blue' ? 'bg-blue' : item.bgType === 'midnight-slate' ? 'bg-midnight-slate' : ''}`}>
                <ProminentWorksDetails withBrand={true} index={index} item={item} />
              </div>
            </Link>
          </div>
        ))}
        {ProminentWorksList.length !== dataList.length && isLoading && (
          <div className="lazy-loader"></div>
        )}
      </div>
    </div>
  );
};

export default ProjectsList;
